import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { CustomTimeOff } from './CustomComponents';
import { ExtensionContext } from './ExtensionForm';
import styledComponent from 'styled-components';

export const ExtensionTimeOff = () => {
  const { control, formState: { errors } } = useFormContext();
  const { disabledFields } = useContext(ExtensionContext);

  return (
    <Controller
      name="timeOffRequest"
      control={control}
      render={({ field }) => (
        <CustomRadioGroup
          {...field}
          disabled={disabledFields.timeOffRequest}
        />
      )}
    />
  );
};

const CustomRadioGroup = ({
  value: { timeOffRequestReason: reason, timeOffRequestDetails: timeOffRequest = [] },
  onChange,
  disabled,
}) => {
  const [hasApprovedChips, setHasApprovedChips] = useState<boolean>(false);

  useEffect(
    () => setHasApprovedChips(timeOffRequest.some(item => item.isApproved)),

    [timeOffRequest],
  );

  const handleRadioBtnChange = newState => {
    onChange({
      timeOffRequestReason: Number.parseInt(newState),
      timeOffRequestDetails: timeOffRequest,
    });
  };

  const handleTimeOffChange = newState =>
    onChange({
      timeOffRequestReason: reason,
      timeOffRequestDetails: newState,
    });

  return (
    <FormControl>
      <RadioGroup
        value={reason}
        onChange={(e, val) => {
          handleRadioBtnChange(val);
        }}
      >
        <CustomControlLabel value={1} control={<Radio />} label="Add Time Off Requests" disabled={disabled} />
        {reason === 1 && <CustomTimeOff disabled={disabled} selected={timeOffRequest} onChange={handleTimeOffChange} />}

        <CustomControlLabel
          value={2}
          control={<Radio />}
          label="Not Required"
          disabled={disabled || hasApprovedChips}
        />

        <CustomControlLabel
          value={3}
          control={<Radio />}
          label="To Be Determined"
          disabled={disabled || hasApprovedChips}
        />
      </RadioGroup>
    </FormControl>
  );
};

const CustomControlLabel = styledComponent(FormControlLabel)`
  width: fit-content;
`;
